import React from 'react';
import { B2BOrganization } from 'types/b2b-organization';
import {
  ListItemCircleClassName,
  ListItemClassName,
  ListItemSelectedClassName,
  ListItemTextClassName,
} from './style';
import { cx } from 'linaria';
import { BriefcaseIcon } from '@fronton/icons-react';

const DATA_QA_ITEM_NAME = 'b2b-profile-change-organization-modal-item';

type ListItemProps = {
  item: B2BOrganization;
  isSelected: boolean;
  onChangeSelected: (value: string) => void;
};

export const ListItem = (props: ListItemProps) => {
  const className = cx(ListItemClassName, props.isSelected ? ListItemSelectedClassName : undefined);

  // FIXME: SONAR: Avoid non-native interactive elements. If using native HTML is not possible,
  // add an appropriate role and support for tabbing, mouse, keyboard, and touch inputs to an interactive content element.
  // INTSERVICE-243
  const onKeyDown = () => {};

  return (
    <div
      className={className}
      onClick={() => props.onChangeSelected(props.item.organizationNumber)}
      onKeyDown={onKeyDown}
      data-qa={`${DATA_QA_ITEM_NAME}-${props.item.name}`}
    >
      <ListItemCircle />
      <div className={ListItemTextClassName}>{props.item.name}</div>
    </div>
  );
};

const ListItemCircle = () => {
  return (
    <div className={ListItemCircleClassName}>
      <BriefcaseIcon />
    </div>
  );
};
